export default class Free {
    static ByType = {
            overlay: false,
            banner: false,
            panel: false,
            logo: false,
            planning: false,
            unknown: false
    };
};




// WEBPACK FOOTER //
// ./src/Free.js